<template>
  <div class="content">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="140px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型" prop="poolType">
            <el-radio-group v-model="propsParams.poolType">
              <el-radio-button label="1">单卡模式</el-radio-button>
              <el-radio-button label="2">总量模式</el-radio-button>
              <el-radio-button label="3">套餐模式</el-radio-button>
              <el-radio-button label="5">后付款模式</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="代理商" prop="userId">
            <el-select v-model="propsParams.userId" placeholder="代理商" filterable clearable>
              <el-option v-for="item in webAgentList" :key="item.userId" :label="'['+item.username+']-'+item.company" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流量池名称" prop="poolName">
            <el-input v-model="propsParams.poolName" placeholder="池名称"></el-input>
          </el-form-item>
          <el-form-item label="运营商" prop="operationType">
            <el-select v-model="propsParams.operationType" placeholder="运营商" multiple filterable clearable>
              <el-option v-for="item in webPoolOperators" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注信息" prop="remark">
            <el-input v-model="propsParams.remark" placeholder="备注信息"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="7">
              <el-form-item label="卡用量展示" prop="showFlow">
                <el-switch v-model="propsParams.showFlow" active-color="#13ce66" inactive-color="#DCDFE6" active-value="1" inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="stopCard">
                <span slot="label">
                  <el-tooltip content="自动停机表示此池子套餐用完后是否执行停机操作" placement="top">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  自动停机
                </span>
                <el-switch v-model="propsParams.stopCard" active-color="#13ce66" inactive-color="#DCDFE6" active-value="1" inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="启用状态" prop="status">
                <el-switch v-model="propsParams.status" active-color="#13ce66" inactive-color="#DCDFE6" active-value="1" inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="12" >
          <el-form-item  prop="singleFlowLimit" >
            <el-input v-model="propsParams.singleFlowLimit" placeholder="每张卡每月峰值，-1表示不限量">
              <template slot="append">MB</template>
            </el-input>
            <span slot="label">
              <el-tooltip content="单卡当月最大使用流量，输入“-1”表示不限量" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              单卡月峰值
            </span>
          </el-form-item>
          <el-form-item prop="cardProductFee" >
            <el-input v-model="propsParams.cardProductFee" placeholder="每张卡每月停机所交费用">
              <template slot="append">元</template>
            </el-input>
            <span slot="label">
              <el-tooltip content="平台对当月停机的单卡收取费用（元/单卡），自然月一直停机状态才会收取停机保号费，收取此费用不再收取功能管理费" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              单卡停机保号费
            </span>
          </el-form-item>
          <el-form-item prop="cardFunctionFee" >
            <el-input v-model="propsParams.cardFunctionFee" placeholder="每张卡每月所交功能管理费">
              <template slot="append">元</template>
            </el-input>
            <span slot="label">
              <el-tooltip content="平台对单卡每月收取功能管理费用（元/单卡）,自然月只要激活一次就收取功能管理费，收取此费用不再收取停机保号费" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              单卡功能管理费
            </span>
          </el-form-item>

          <!-- 单卡模式 -->
          <div v-if="propsParams.poolType == '1'">
            <el-form-item label="单卡低消流量" prop="singleLowFlow" :required="true" :rules="{ required: true, message: '单卡低消流量不能为空', trigger: 'blur' }">
              <el-input v-model="propsParams.singleLowFlow" placeholder="单卡低消流量">
                <template slot="append">MB</template>
              </el-input>
              <span slot="label">
                <el-tooltip content="平台对单卡每月设置一个最低消耗流量，先按低消收费，再按超出部分收费" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                单卡低消流量
              </span>
            </el-form-item>
            <el-form-item prop="singleLowFlowFee" :required="true" :rules="{ required: true, message: '单卡低消流量费用不能为空', trigger: 'blur' }" >
              <el-input v-model="propsParams.singleLowFlowFee" placeholder="单卡低消流量费用">
                <template slot="append">元</template>
              </el-input>
              <span slot="label">
                <el-tooltip content="平台对单卡按低消流量进行结算，未超过低消流量按低消流量结算，超过部分另外计算" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                单卡低消费用
              </span>
            </el-form-item>
            <el-form-item prop="singleOverFlowFee" :required="true" :rules="{ required: true, message: '超出低消流量价格不能为空', trigger: 'blur' }">
              <el-input v-model="propsParams.singleOverFlowFee" placeholder="超出低消流量价格">
                <template slot="append">元/GB</template>
              </el-input>
              <span slot="label">
                <el-tooltip content="平台对超过低消流量的卡，超过低消流量部分按每GB收取费用（单卡月流量-低消）*超流单价" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                超流单价
              </span>
            </el-form-item>
          </div>
          <!-- 总量模式 -->
          <div v-if="propsParams.poolType == '2'">
            <el-form-item  prop="poolTotalFlow" :required="true" :rules="{ required: true, message: '池总量不能为空', trigger: 'blur' }">
              <el-input v-model="propsParams.poolTotalFlow" placeholder="池总量">
                <template slot="append">MB</template>
              </el-input>
              <span slot="label">
                <el-tooltip content="每月流量池总量" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                池总量
              </span>
            </el-form-item>
            <el-form-item label="流量池单价" prop="poolTotalFlowFee" :required="true" :rules="{ required: true, message: '流量池价格不能为空', trigger: 'blur' }">
              <el-input v-model="propsParams.poolTotalFlowFee" placeholder="流量池价格">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
          <!-- 套餐模式 -->
          <div v-if="propsParams.poolType == '3'">
            <el-form-item label="单卡月流量" prop="singleFlow" :required="true" :rules="{ required: true, message: '单卡月流量不能为空', trigger: 'blur' }">
              <el-input v-model="propsParams.singleFlow" placeholder="每月单卡可用流量">
                <template slot="append">MB</template>
              </el-input>
              <span slot="label">
                <el-tooltip content="每月单卡基础流量，超过单卡峰值将会停机，池卡总使用流量不能超过单卡月流量*池卡数" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                单卡月流量
              </span>
            </el-form-item>
            <el-form-item label="单卡月费用" prop="singlePrice" :required="true" :rules="{ required: true, message: '单卡月流量费用不能为空', trigger: 'blur' }">
              <el-input v-model="propsParams.singlePrice" placeholder="每月单卡流量需支付金额">
                <template slot="append">元</template>
              </el-input>
              <span slot="label">
                <el-tooltip content="每月单卡流量费用" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                单卡月费用
              </span>
            </el-form-item>
          </div>
          <!-- 后付款模式 -->
          <div v-if="propsParams.poolType == '5'">
            <el-form-item label="流量单价" prop="singlePrice" :required="true" :rules="{ required: true, message: '每月每GB流量单价不能为空', trigger: 'blur' }">
              <el-input v-model="propsParams.singlePrice" placeholder="每GB流量单价">
                <template slot="append">元/GB</template>
              </el-input>
              <span slot="label">
                <el-tooltip content="每月池子卡流量按 元/GB 收费" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                流量单价
              </span>
            </el-form-item>
          </div>
        </el-col>

      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { poolSavePool , poolGetFlowPoolInfo} from "@/api/api.js";
import { agentDataList } from "@/api/api.js";
export default {
  name:"pondAdd",
  data() {
    return{
      propsParams:{
        status:"1",
        showFlow:"1",
        poolType:'1',
        stopCard:"1"
      },
      isSingleCardMode:false,
      isTotalFlowMode:false,
      isSetMealMode:false,
      isPostPayment:false,
      ruleValidate:{
        poolName:[
          { required: true, message: "请输入流量池名称", trigger: "blur" },
          { min: 3,max: 18,message: "请输入3至18字母数字或汉字",trigger: "blur"},
        ],
        userId:[
          { required: true, message: "请选择代理商", trigger: "blur" },
        ],
        poolType:[
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
        operationType:[
          { required: true, message: "请选择运营商", trigger: "blur" },
        ],
        singleFlowLimit:[
          { required: true, message: "请选择单卡月峰值", trigger: "blur" },
        ],
        cardProductFee:[
          { required: true, message: "请选择单卡停机保号费", trigger: "blur" },
        ],
        cardFunctionFee:[
          { required: true, message: "请选择单卡功能管理费", trigger: "blur" },
        ],

      },
      webAgentList:[],
      webPoolType:[
        { value:"1",label:"单卡模式" },
        { value:"2",label:"总量模式" },
        { value:"3",label:"套餐模式" },
        { value:"5",label:"后付款模式" },
      ],
      webPoolOperators:[
        { value:"3",label:"中国电信" },
        { value:"1",label:"中国移动" },
        { value:"2",label:"中国联通" },
      ],
    }
  },
  methods: {
    // 获取流量池用户
    initData(){
      agentDataList({commissionModel:'2'}).then(res => {
        this.webAgentList = res.data.data
      })
    },
    // 创建流量池
    handleSubmit(){
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          let params ={
            ...this.propsParams
          }
          poolSavePool(params).then(res => {
            this.$message.success("添加流量池成功");
            this.propsParams = {
                status:"1",
                showFlow:"1",
                poolType:'1',
                stopCard:"1"
            }
            this.$router.push(`/pondManage/pondList`);
          })
        }
      })
    },
    initPoolData(){
      let poolId = this.$route.query && this.$route.query.poolId
      if(!!poolId){
        poolGetFlowPoolInfo({poolId}).then(res=>{
          this.propsParams = res.data.data;
          this.propsParams.operationType = JSON.parse(this.propsParams.operationType).map(String);
        })
      }
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'pondAdd'){
          this.initData();
        }
      },
      deep: true
    }
  },
  created() {
    this.initData()
    this.initPoolData()
  }
};
</script>

<style scoped lang="less">
  .el-select {
    width: 405px;
  }
  .el-input {
    width: 405px;
  }
</style>


